import TranQuery from './resources/TranQuery'
import { createTranAdjustController } from './tran/adjust/tranAdjustController'
import { createPayTranModel } from './tran/resources/tranModel'
import { createTranAdjustQuery } from './tran/resources/tranAdjustQuery'

export default {
  'tranQuery': ['factory', TranQuery],
  'tranAdjustQuery': ['factory', createTranAdjustQuery],
  'tranModel': ['factory', createPayTranModel],
  'tranAdjustController': ['factory', createTranAdjustController],
}

//** example of setting up child */
// import injector from '../injector'
// import {BatchQuery} from './resources/BatchQuery'

// const appModule = {
//   'batchQuery': ['factory', BatchQuery],
// }
// const child = injector.createChild([ appModule ]);

// export default child
